// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tankImage {\r\n  max-height: 100px;\n}\n.batteryGood {\r\n  color: var(--green-500) !important;\n}\n.batteryWarning {\r\n  color: var(--yellow900) !important;\n}\n.batteryCritical {\r\n  color: var(--red-500) !important;\n}\n.tu-row-2 {\r\n  padding-top: 35px;\n}\n.colorGray700 {\r\n  color: var(--carbon-600) !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
